import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { SupplierTypeInversed, SupplierTypeKeys } from '@teinor/erp/types/company/supplier'
import { ButtonPrimary, ButtonSecondary } from '../../../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../../baseComponents/PermissionChecker'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import { BaseScreenPageData } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { SetEditDeleteModalTy, UseEditDeleteModalProps } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalImportSuppliers from '../../SuppliersParent/RightHeaderTableSuppliers/ModalImportSuppliers'

interface RightHeaderTableCreditorsProps extends ComponentWithPermissions {
    pageData: BaseScreenPageData
    openModal: UseEditDeleteModalProps
    setOpenModal: SetEditDeleteModalTy
    updateTableInstance: () => void
}

const RightHeaderTableCreditors: React.FC<RightHeaderTableCreditorsProps> = ({ updateTableInstance, openModal, setOpenModal, pageData, userPermissions }) => {
    const {t} = useTwinTranslation()
    return (
        <div className='flex items-center'>
            <ButtonSecondary className='mr-10' onClick={() => { setOpenModal({ type: 'edit', allRowData: {} }) }}><TwinTrans transKey='importCreditors'>Importar Acreedores</TwinTrans></ButtonSecondary>
            {openModal?.type === 'edit' ? <ModalImportSuppliers onSubmit={updateTableInstance} allRowData={openModal.allRowData} {...{ setOpened: () => setOpenModal(null) }} typeSupplier={SupplierTypeInversed['creditor'] as SupplierTypeKeys} title={t('importCreditors', 'Importar acreedores')} /> : null}
            <PermissionChecker userPermissions={userPermissions} permission='create'>
                {pageData.newText && <ButtonPrimary onClick={() => setOpenModal({ type: 'create', allRowData: {} })}>
                    <TwinIcon icon={faPlus} className='mr-8' />
                    {pageData.newText}
                </ButtonPrimary>}
            </PermissionChecker>
        </div>
    )
}

export default RightHeaderTableCreditors